import {SelectItem} from '@/store/types';

export interface StatisticState {
    smsStatisticDetail?: any,
    smsStatisticDetailIncoming: SmsDetailIncomingItem[],
    smsStatisticGroup?: any,
    smsStatisticGroupIncoming?: SmsGroupIncomingItem[],
    smsGroupings: {
        smsGroup: string[],
        smsGroupOptionally: string[],
    },
}

export class GroupFilterParams {
    message_direction: string = 'mt';
    date_from: string;
    date_to: string;
    group_by: string;
    template_id?: number|null = undefined;
    bulk_id?: string|null = undefined;
    message_type?: string|null = undefined

    constructor(date_from: string, date_to: string, group_by: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.group_by = group_by;
    }
}

export interface GroupItem {
    Date?: string|any;
    originator?: string;
    service_provider?: string;
    partner?: string;
    recipient_operator?: string;
    template_id?: string;
    bulk_id?: string;
    Finished?: number;
    NotAnswered?: number;
    Error?: number;
    Rejected?: number;
    Deferred?: number;
    CallsCount?: number;
    Charged?: string;
  }

export interface SmsGroupIncomingItem {
    date?: string,
    service_number?: string,
    partner?: string,
    originator_operator?: string,
    service_provider?: string,
    broker_account_login?: string,
    processed: number,
    error: number,
    total: number,
}

export class DetailFilterParams {
    message_direction:string = 'mt';
    date_from: string;
    date_to: string;
    originator?: string = undefined;
    recipient?: number = undefined;
    partner?: string = undefined;
    service_provider?: string = undefined;
    status?: string = undefined;
    message_category?: string = undefined;
    error_code?: string = undefined;
    message_type?: string = undefined;
    message?: string = undefined;
    sent_date_from?: string = undefined;
    sent_date_to?: string = undefined;
    deliver_date_from?: string = undefined;
    deliver_date_to?: string = undefined;
    template_id?: number = undefined;
    bulk_id?: string = undefined;
    operator?: string = undefined;
    broker_account_login?: string = undefined;
    partner_user_login?: string = undefined;
    id?: string = undefined;
    provider_message_id?: string = undefined;
    external_id?: string = undefined;
    ext_id1?: string = undefined;
    ext_id2?: string = undefined;
    ext_id3?: string = undefined;
    ext_id4?: string = undefined;
    ext_id5?: string = undefined;
    ext_id6?: string = undefined;
    provider_protocol?: string = undefined;
    page_number: number = 1;

    constructor(date_from: string, date_to: string) {
        this.date_from = date_from;
        this.date_to = date_to;
    }
}

export interface DetailItem {
    date_from: string,
    originator: string,
    recipient: string,
    partner: string,
    service_provider: string,
    content: string,
    status: string,
    error_code: number|null,
  }

export interface IDetailFilterParams {
    date_from: string | null,
    date_to: string | null,
    originator?: string | null,
    recipient?: number | null,
    partner?: string | null,
    service_provider?: string | null,
    status?: string | null,
    message_category?: string | null,
    error_code?: string | null,
    message_type?: string | null,
    message?: string | null,
    sent_date_from?: string | null,
    sent_date_to?: string | null,
    deliver_date_from?: string | null,
    deliver_date_to?: string | null,
    template_id?: string | null,
    bulk_id?: string | null,
    operator?: string | null,
    broker_account_login?: string | null,
    partner_user_login?: string | null,
    id?: string | null,
    provider_message_id?: string | null,
    external_id?: string | null,
    ext_id1?: string | null,
    ext_id2?: string | null,
    ext_id3?: string | null,
    ext_id4?: string | null,
    ext_id5?: string | null,
    ext_id6?: string | null,
    provider_protocol?: string | null,
}

export class SmsDetailItemInfo {
    recipient: string = ""
    country: string = ""
    originator: string = ""
    message_parts: number | null = null
    message: string = ""
    status: string = ""
    partner_user_login: string = ""
    id: string = ""
    partner_price: null | string = null
    operator: string = ""
    broker_account_login: null | string = null
    template_id: number | null = null
    bulk_id: string | null = null
    sent_date: string | null = null
    connection_type: string | null = null
    custom_data?: string;
    ext_id1?: string | null
    ext_id2?: string | null
    ext_id3?: string | null
    ext_id4?: string | null
    ext_id5?: string | null
    ext_id6?: string | null
    provider_message_id?: string | null
    provider_protocol?: string | null
}

export interface SmsGroupIncomItem {
    date?: string,
    processed: number,
    error: number,
    total: number,
}

export class SmsDetailIncomingFilterParams {
    date_from: string;
    date_to: string;
    originator?: string = undefined;
    service_number?: string = undefined;
    service_provider?: string = undefined;
    partner?: string = undefined;
    status?: string = undefined;
    error_code?: string = undefined;
    flag: string | null = null;

    constructor(date_from: string, date_to: string) {
        this.date_from = date_from;
        this.date_to = date_to;
    }
}

export interface SmsDetailIncomingItem {
    id: string,
    create_date: string,
    originator: string,
    service_number: string,
    service_provider: string,
    partner: string,
    message: string,
    status: string,
    error_code?: number,
}

export class SmsDetailIncomingItemInfo {
    id: string | null = null;
    create_date: string | null = null;
    module: string | null = null;
    service_provider: string | null = null;
    originator: string | null = null;
    originator_operator?: string = undefined;
    originator_country?: string = undefined;
    service_number: string | null = null;
    partner?: string = undefined;
    broker_account_login?: string = undefined;
    status: string | null = null;
    error_code?: number = undefined;
    error_description?: string = undefined;
    message: string | null = null;
}
